import * as React from "react";
const ShelterIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#shelter_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 22.995c-4.988 0-8.75 3.403-8.75 7.916a1.25 1.25 0 0 0 2.5 0 5.192 5.192 0 0 1 2.917-4.625V46.75a1.25 1.25 0 0 0 2.5 0V36.333h1.667V46.75a1.25 1.25 0 0 0 2.5 0V26.286a5.19 5.19 0 0 1 2.917 4.625 1.25 1.25 0 0 0 2.5 0c0-4.513-3.762-7.916-8.75-7.916ZM28.044 21.333a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.965 18.7 29.048 8.283a2.083 2.083 0 0 0-2.095 0L9.036 18.7A2.083 2.083 0 0 0 8 20.5v25.417a2.083 2.083 0 1 0 4.167 0V21.699L28 12.494l15.834 9.206v24.218a2.083 2.083 0 1 0 4.167 0V20.499a2.084 2.084 0 0 0-1.036-1.8Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "shelter_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default ShelterIcon;